import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AracCheckupPage = lazy(() => import('../pages/blog/arac-checkup-periyodik-kontrol/page'));
const ArizaTeshisPage = lazy(() => import('../pages/blog/ariza-teshis-elektronik-sistem/page'));
const DrecuYazilimPage = lazy(() => import('../pages/blog/drecu-yazilim-hizmetleri/page'));
const HasarDanismanligiPage = lazy(() => import('../pages/blog/hasar-danismanligi-kaza-onarimi/page'));
const MotorRektifiyePage = lazy(() => import('../pages/blog/motor-rektifiye-mekanik-tamir/page'));
const SanzimanTamirPage = lazy(() => import('../pages/blog/sanziman-tamir-bakim/page'));
const SonTeknolojiTeshisPage = lazy(() => import('../pages/blog/son-teknoloji-teshis/page'));
const GarantiliHizmetPage = lazy(() => import('../pages/blog/garantili-hizmet/page'));
const UzmanKadroPage = lazy(() => import('../pages/blog/uzman-kadro/page'));
const HizliServisPage = lazy(() => import('../pages/blog/hizli-servis/page'));
const UstSegmentUzmanligiPage = lazy(() => import('../pages/blog/ust-segment-uzmanligi/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog/hasar-danismanligi-kaza-onarimi',
    element: <HasarDanismanligiPage />,
  },
  {
    path: '/blog/motor-rektifiye-mekanik-tamir',
    element: <MotorRektifiyePage />,
  },
  {
    path: '/blog/sanziman-tamir-bakim',
    element: <SanzimanTamirPage />,
  },
  {
    path: '/blog/drecu-yazilim-hizmetleri',
    element: <DrecuYazilimPage />,
  },
  {
    path: '/blog/arac-checkup-periyodik-kontrol',
    element: <AracCheckupPage />,
  },
  {
    path: '/blog/ariza-teshis-elektronik-sistem',
    element: <ArizaTeshisPage />,
  },
  {
    path: '/blog/son-teknoloji-teshis',
    element: <SonTeknolojiTeshisPage />,
  },
  {
    path: '/blog/garantili-hizmet',
    element: <GarantiliHizmetPage />,
  },
  {
    path: '/blog/uzman-kadro',
    element: <UzmanKadroPage />,
  },
  {
    path: '/blog/hizli-servis',
    element: <HizliServisPage />,
  },
  {
    path: '/blog/ust-segment-uzmanligi',
    element: <UstSegmentUzmanligiPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;